Controller.$inject = ['$element', '$timeout'];

function Controller($element, $timeout) {
    const self = this;

    self.showLegend = false;
    self.inputFocused = false;

    self.handleFocus = () => {
        handleFlagContainerFocus();
        self.inputFocused = true;
    };

    const handleFlagContainerFocus = () => {
        const flagContainer = $element[0].querySelector('.iti__flag-container');
        if (flagContainer) {
            flagContainer.classList.add('focus-visible');
        }
    };

    self.handleBlur = () => {
        const flagContainer = $element[0].querySelector('.iti__flag-container');
        if (flagContainer) {
            flagContainer.classList.remove('focus-visible');
            self.inputFocused = false;
        }
    };

    self.handleChange = ($event) => {
        $timeout(() => {
            self.onChange({$event});
        })
    };

    self.$postLink = () => {
        $timeout(() => {
            if (self.labelVariant === 'outlined') {
                const selectedFlag = $element[0].querySelector('.iti__selected-flag');
                selectedFlag.classList.add('outlined');
                handleFlagContainerFocus();
            }
        }, 0);
    };
}

export function HuiInputPhone() {
    return {
        restrict: 'E',
        scope: true,
        bindToController: {
            ngModel: '=',
            labelVariant: '@',
            disabled: '<',
            hName: '@',
            hasError: '<',
            placeholder: '@',
            onChange: '&',
            fullWidth: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: {
            label: '?huiInputLabel'
        },
        template: ($element, $attrs) => {
            return `
              <hui-input-base
                label-variant="{{$huiCtrl.labelVariant}}"
                has-error="$huiCtrl.hasError"
                model-value="$huiCtrl.ngModel"
                input-focused="$huiCtrl.inputFocused"
                show-legend="$huiCtrl.labelVariant === 'outlined' ? true : false"
                disabled="$huiCtrl.disabled"
                full-width="$huiCtrl.fullWidth"
             >
                <hui-input-base-label ng-transclude ng-transclude-slot="label"></hui-input-base-label>
                <input type="tel"
                       ng-model="$huiCtrl.ngModel"
                       ng-disabled="$huiCtrl.disabled"
                       placeholder="{{$huiCtrl.labelVariant !== 'outlined' ? $huiCtrl.placeholder : ''}}"
                       name="{{$huiCtrl.hName}}"
                       class="hui-base-input"
                       ng-focus="$huiCtrl.handleFocus()"
                       ng-blur="$huiCtrl.handleBlur()"
                       ng-change="$huiCtrl.handleChange($event)"
                       h-intl-tel-input
                />
              </hui-input-base>
             `;
        }
    };
}
